import { PrimaryButton } from 'components';
import { useNavigate } from 'react-router-dom';

const NotAvailable = () => {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate('/');
  };
  return (
    <div className="d-flex align-items-center justify-content-center flex-column vh-100 vw-100">
      <h1 style={{ color: 'gray', marginBottom: -20 }}>Whoops!</h1>
      <h2 style={{ color: 'gray', padding: '40px' }}>The page you&apos;re looking for isn&apos;t available.</h2>
      <PrimaryButton onClick={handleGoHome}>
        Back to home
      </PrimaryButton>
    </div>
  );
};
export default NotAvailable;
